import { useEffect, useState } from 'react';

export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [crystalPositions, setCrystalPositions] = useState<
    Array<{ x: number; y: number; rotation: number; scale: number }>
  >([]);

  useEffect(() => {
    try {
      const positions = Array.from({ length: 8 }, () => ({
        x: Math.random() * 100,
        y: Math.random() * 100,
        rotation: Math.random() * 360,
        scale: 0.5 + Math.random() * 0.5,
      }));
      setCrystalPositions(positions);
    } catch (e) {
      console.error('Failed to generate crystal positions:', e);
    }
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-[80vh] md:min-h-screen flex items-start justify-start overflow-hidden bg-gradient-to-b from-gray-50 to-white">
      <div className="absolute inset-0 overflow-hidden">
        {crystalPositions.map((pos, index) => (
          <div
            key={index}
            className="absolute animate-float"
            style={{
              left: `${pos.x}%`,
              top: `${pos.y}%`,
              transform: `rotate(${pos.rotation}deg) scale(${pos.scale})`,
              animationDelay: `${index * 0.5}s`,
              animationDuration: `${3 + index * 0.5}s`,
            }}
          >
            <div
              className={`w-8 h-8 md:w-12 md:h-12 ${
                index % 4 === 0
                  ? 'bg-yellow-400'
                  : index % 4 === 1
                  ? 'bg-green-400'
                  : index % 4 === 2
                  ? 'bg-red-400'
                  : 'bg-teal-400'
              } opacity-20 blur-sm`}
              style={{ clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)' }}
            />
          </div>
        ))}
      </div>

      {/* Truck image - responsive sizing */}
      <div className="absolute bottom-0 right-0 w-full h-full pointer-events-none">
        <div
          className={`absolute bottom-0 right-0 w-full sm:w-[80%] md:w-[65%] lg:w-[58%] h-[50%] sm:h-[60%] md:h-[70%] lg:h-[75%] transition-all duration-1000 ease-out ${
            isLoaded ? 'opacity-90 translate-x-0' : 'opacity-0 translate-x-20'
          }`}
        >
          <img
            src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/da842b779d684e5d3ae48aacdbc0484d.png"
            alt="Truck"
            className="w-full h-full object-contain object-bottom"
          />
        </div>
      </div>

      <div className="relative z-10 text-left px-6 md:px-12 lg:px-20 w-full max-w-3xl pt-32 sm:pt-36 md:pt-40 lg:pt-48">
        <h2
          className={`text-3xl sm:text-4xl md:text-6xl font-black text-gray-900 leading-tight mb-6 md:mb-8 transition-all duration-700 ease-out ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          今できることを、<br />
          <span className="text-teal-500">大切に。</span>
        </h2>
        <p
          className={`text-base md:text-xl text-gray-600 font-medium transition-all duration-700 ease-out delay-300 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '0.4s' }}
        >
          HOUJYU UNYU
        </p>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
